<template>
  <div>
    <!-- :title="headNavImg.title"
    :titleEn="headNavImg.profiles" -->
    <!-- <HeadNav
      :src="headNavImg.picture"
      :head="false"
      homePage
    ></HeadNav> -->
    <div style="height:100%;">
      <div ref="swiper-container" class="swiper-container banner">
          <div class="swiper-wrapper">
              <div class="swiper-slide" style="position:relative;">
                  <img src="../assets/home1.png" alt="">
                  <div class="navLogo" v-if="!head">
                    <img :src='require("../assets/聚跃倾斜logo.png")' alt="">
                  </div>
              </div>
              <div class="swiper-slide parentTitle">
                  <img src="../assets/home2.png" alt="">
                  <div class="titleHead">
                    <div>中国“芯”  全球“心”</div>
                    <div>China Core Global Core</div>
                  </div>
              </div>
              <div class="swiper-slide parentTitle">
                  <img src="../assets/home3.png" alt="">
                   <div class="titleHead">
                    <div>集成电路检测公共技术服务平台</div>
                    <div>Integrated Circuit Inspection Public Technology Service Platform</div>
                  </div>
              </div>
          </div>
          <div ref="swiper-pagination" class="swiper-pagination positionPag"></div>
      </div>
    </div>
    <div class="projectBg">
      <el-row class="projectClass">
        <div class="projectParent">
          <Title title="关于我们" titleEn="ABOUT US"></Title>
        </div>
        <!-- 关于我们pc -->
        <div  class="about_us">
          <div class="about_us_left">
            <img src="../assets/imgProfile1.png" alt="">
          </div>
          <div class="about_us_right">
            <div class="about_us_right_top">{{aboutUSText}}</div>
            <div class="about_us_right_bottom">
              <div class="about_us_right_bottom_button" @click="goAboutUs('./about?value=01&id=1')">查看更多</div>
            </div>
          </div>
        </div>
        <!-- 关于我们moblie -->
        <div  class="about_us_mobile">
          <div class="about_us_mobile_top">
            <img src="../assets/imgProfile1.png" alt="">
          </div>
          <div class="about_us_mobile_middle">{{aboutUSText}}</div>
          <div class="about_us_mobile_bottom">
              <div class="about_us_mobile_bottom_button" @click="goAboutUsMoblie('/about?value=01&id=1')">查看更多</div>
          </div>
        </div>
        <div class="projectParent">
          <Title title="服务项目" titleEn="SERVICES"></Title>
        </div>
        <!-- 服务项目PC -->
        <el-row :gutter="100" class="projectRow">
          <!-- <el-col :span="8" v-for="(item,index) in list" :key="item">
            <div class="project animated fadeInUp"  @click="projectRow(item.children[0].id,index + 1)"> 
              <img :src="item.backPicture" alt />
              <div class="projectIcon">
              </div>
              <div class="projectText">{{item.title}}</div>
            </div>
          </el-col> -->
          <!-- <div class="firstImg">
            <div class="left1">
              <img src="../assets/proImg1.png" alt="">
              <div class="comTxtCont">
                <div class="comTitle">CL化性分析项目</div>
                <div class="comPro">采用laser镭射开盖机和RIE（反应离子刻蚀)机等专用设备配合聚跃技术可以处理几乎国内所有IC开盖和去层</div>
                <div class="more"  @click="projectRow(proId1,1)">查看更多</div>
              </div>
            </div>
            <div class="right1">
              <img src="../assets/proImg2.png" alt="">
              <div class="comTxtCont">
                <div class="comTitle">FA失效分析项目</div>
                <div class="comPro">提供Probe探针测试、I/V曲线测试、SAT无损检查、X-RAY无损检查、EMMI/InGaAas/OBIRCH失效点定位、SEM电子显微镜检查</div>
                <div class="more" @click="projectRow(proId3,3)">查看更多</div>
              </div>
            </div>
          </div>
          <div class="secondImg">
            <div class="left2">
              <div class="aa">
                <img src="../assets/proImg3.png" alt="">
                <div class="comTxtCont">
                  <div class="comTitle">FIB（聚焦离子束）项目</div>
                  <div class="comPro">聚跃拥有多台FIB设备，设备型号主要有DualBeam、V600、STRAT400S、G5等，24小时不间断运作</div>
                  <div class="more" @click="projectRow(proId2,2)">查看更多</div>
                </div>
              </div>
              <div class="aa">
                <img src="../assets/proImg4.png" alt="">
                <div class="comTxtCont">
                  <div class="comTitle">ESD静电放电<br/>Latch-Up闩锁测试项目</div>
                  <div class="comPro">静电放电和Latch-up闩锁测试：HBM人体模型测试、MM机器模型测试、CDM充电件模型测试、Latch-up闩锁测试</div>
                  <div class="more" @click="projectRow(proId4,4)">查看更多</div>
                </div>
              </div>
            </div>
            <div class="center2">
              <div class="aa">
                <img src="../assets/proImg5.png" alt="">
                <div class="comTxtCont">
                  <div class="comTitle">RA可靠性测试项目</div>
                  <div class="comPro">高温敏感性实验、高温存储实验、温度循环实验、高温高湿寿命实验、冷热冲击实验、早期筛选实验、高低温工作寿命实验</div>
                  <div class="more" @click="projectRow(proId5,5)">查看更多</div>
                </div>
              </div>
              <div class="aa">
                <img src="../assets/proImg6.png" alt="">
                <div class="comTxtCont">
                  <div class="comTitle">ASSY快速封装项目</div>
                  <div class="comPro">聚跃拥有多台打线机，可以提供各种管壳及COB封装等相关服务</div>
                  <div class="more" @click="projectRow(proId6,6)">查看更多</div>
                </div>
              </div>
            </div>
            <div class="right2">
              <img src="../assets/proImg.png" alt="">
              <div class="comTxtCont">
                  <div class="comTitle">竞争力分析</div>
                  <div class="comPro">致力于为客户提供专业高效的芯片解析服务，帮助IC设计企业了解世界上同业的先进设计和先进制程技术，协助客户做好自有产品的设计，促进国内集成电路行业的发展</div>
                  <div class="more"  @click="goPage2('./business?value=0&id=0')">查看更多</div>
                </div>
            </div>
          </div> -->
          <div class="firstImg">
            <div class="left1">
              <img src="../assets/proImg1.png" alt="">
              <div class="comTxtCont">
                <div class="comTitle">失效分析</div>
                <div class="comPro">提供Probe探针测试、I/V曲线测试、SAT无损检查、X-RAY无损检查、EMMI/InGaAas/OBIRCH失效点定位、SEM电子显微镜检查。</div>
                <div class="more" @click="projectRow(proId3,3)">查看更多</div>
              </div>
            </div>
            <div class="right1">
              <img src="../assets/proImg5.png" alt="">
              <div class="comTxtCont">
                <div class="comTitle">可靠性分析</div>
                <div class="comPro">高温敏感性实验、高温存储实验、温度循环实验、高温高湿寿命实验、冷热冲击实验、早期筛选实验、高低温工作寿命实验。</div>
                <div class="more" @click="projectRow(proId5,5)">查看更多</div>
              </div>
            </div>
          </div>
          <div class="secondImg">
            <div class="left2">
              <div class="aa">
                <img src="../assets/proImg4.png" alt="">
                <div class="comTxtCont">
                  <div class="comTitle">自研设备</div>
                  <div class="comPro">由上海聚跃集团和原中科院微电子所微纳工艺设备团队核心成员共同组建，双方优势互补，机台研发和工艺验证相辅相成，实现多种机台的工艺优化和升级迭代，旨在打造国产化高端微纳工艺装备。</div>
                  <div class="more" @click="goPage2('./sale?value=196&id=254')">查看更多</div>
                </div>
              </div>
              <div class="aa">
                <img src="../assets/proImg6.png" alt="">
                <div class="comTxtCont">
                  <div class="comTitle">汽车电子测试</div>
                  <div class="comPro">汽车电子测试中心是以其他四大中心为支撑，为中国汽车芯片特别是新能源的高功率芯片可靠性保证出一份力。</div>
                  <div class="more" @click="projectRow(proId7,7)">查看更多</div>
                </div>
              </div>
            </div>
            <div class="left3">
              <div class="aa">
                <img src="../assets/proImg3.png" alt="">
                <div class="comTxtCont">
                  <div class="comTitle">材料分析</div>
                  <div class="comPro">聚跃拥有多台FIB设备，设备型号主要有DualBeam、V600、STRAT400S、G5等，24小时不间断运作。</div>
                  <div class="more" @click="projectRow(proId2,8)">查看更多</div>
                </div>
              </div>
            </div>
          </div>

        </el-row>
        <!-- 服务项目mobile -->
        <div class="projectRowMobile">
          <div class="projectRowMobile_top animated fadeInUp" @click="projectRowMobile(list[2])">
              <img src="../assets/proImg1.png" alt />
              <div class="projectText">失效分析</div>
          </div>
          <div class="projectRowMobile_bottom">
            <div class="projectRowMobile_bottom_top" style="margin-bottom: 20px;">
              <div class="projectRowMobile_bottom_top_item animated fadeInUp" @click="projectRowMobile(list[4])">
                <img src="../assets/proImg5.png" alt />
                <div class="projectText">可靠性分析</div>
              </div>
              <div class="projectRowMobile_bottom_top_item animated fadeInUp" @click="goPage2('./sale?value=196&id=254')">
                <img src="../assets/proImg4.png" alt />
                <div class="projectText">自研设备</div>
              </div>
            </div>
            <div class="projectRowMobile_bottom_top">
              <div class="projectRowMobile_bottom_top_item animated fadeInUp" @click="projectRowMobile(list[6])">
                <img src="../assets/proImg5.png" alt />
                <div class="projectText">汽车电子测试</div>
              </div>
              <div class="projectRowMobile_bottom_top_item animated fadeInUp" @click="projectRowMobile(list[7])">
                <img src="../assets/proImg3.png" alt="">
                <div class="projectText">材料分析</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <el-row class="projectRowMobile" :gutter="20" >
          <el-col :span="12" v-for="(item,index) in list" :key="index">
            <div class="project animated fadeInUp"  @click="projectRowMobile(item)">
              <img :src="item.backPicture" alt />
              <div class="projectText">{{item.title}}</div>
            </div>
          </el-col>
        </el-row> -->

        <div class="deviceParent">
          <Title title="检测设备" titleEn="DEVICES"></Title>
        </div>
        <!-- 流式轮播 -->
        <div class="devices">
          <ul class="devicesUl" ref="devicesUl">
            <li v-for="(item) in DevicesList" :key="item" @click="goPage('./sale?value='+ getValue2 +'&cId=' + item.cId,index)">
              <img :src="item.src" alt />
              <div class="deviceTxt" v-html="item.profile"></div>
            </li>
             <li v-for="(item) in DevicesList" :key="item" @click="goPage('./sale?value='+ getValue2 +'&cId=' + item.cId,index)">
              <img :src="item.src" alt />
              <div class="deviceTxt" v-html="item.profile"></div>
            </li>
            <li v-for="(item) in DevicesList" :key="item" @click="goPage('./sale?value='+ getValue2 +'&cId=' + item.cId,index)">
              <img :src="item.src" alt />
              <div class="deviceTxt" v-html="item.profile"></div>
            </li>
          </ul>
        </div>
        <!-- 新闻动态 -->
        <div class="news">
          <Title title="新闻动态" titleEn="INFORMATIONS"></Title>
        </div>
        <!-- 新闻PC -->
        <div class="news_pc">
          <div class="news_pc_left">
            <div class="news_pc_left_top" @click="getClickNewsDetail(activeNewsDetail)">
              <img :src="activeNewsDetail.picture" alt="">
            </div>
            <div class="news_pc_left_bottom">
              <div class="news_pc_left_bottom_top" @click="getClickNewsDetail(activeNewsDetail)">{{activeNewsDetail.title}}</div>
              <div class="news_pc_left_bottom_middle" @click="getClickNewsDetail(activeNewsDetail)">{{activeNewsDetail.profile}}</div>
              <div class="news_pc_left_bottom_bottom">
                <div class="news_pc_left_bottom_bottom_left" @click="getClickNewsDetail(activeNewsDetail)">{{getTime(activeNewsDetail.releaseTime)}}</div>
                <div class="news_pc_left_bottom_bottom_right">
                  <div class="news_pc_left_bottom_bottom_right_button" style="margin-right: 10px;" @click="handlePre">
                    <img src="../assets/left.png" alt="">
                  </div>
                  <div class="news_pc_left_bottom_bottom_right_button" @click="handleNext">
                    <img src="../assets/right.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="news_line"></div>
          <div class="news_pc_right">
            <div class="news_pc_right_top">
              <div class="news_pc_right_top_left">新闻动态</div>
              <div class="news_pc_right_top_right" @click="goMoreNews('/news?value=02&id=0')">查看更多</div>
            </div>
            <div class="news_pc_right_content">
              <div class="news_pc_right_content_item" @click="getClickNewsDetail(item)" v-for="(item,index) in newsData" :key="index">
                <div class="news_pc_right_content_item_left">
                  <img :src="item.picture" alt="">
                </div>
                <div class="news_pc_right_content_item_right">
                  <div class="news_pc_right_content_item_right_title">{{item.title}}</div>
                  <div class="news_pc_right_content_item_right_time">{{getTime(item.releaseTime)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="news_mobile_right_bottom">
          <div class="news_mobile_right_bottom_button" @click="goMoreNews('/news?value=02&id=0')">查看更多</div>
        </div>
        <!-- 新闻mobile -->
        <div class="news_mobile">

        </div>
        <!-- <div class="partner2">
          <Title title="合作伙伴" titleEn="PARTNER"></Title>
        </div> -->
         <!-- 合作伙伴 PC -->
         <!-- <div  class="MarginPartner">
          <div class="partnerDiv">
            <el-row :gutter="50">
              <el-col :span="4" v-for="item in partnerList" :key="item">
                <el-image style="width: auto; height: 80px" :src="item" fit="contain" lazy></el-image>
              </el-col>
            </el-row>
            <div class="p_img" v-for="item in partnerList" :key="item">
              <img :src="item" alt="">
            </div>
          </div>
        </div> -->
        <!-- <div  class="MarginPartner">
          <div class="partnerDiv">
            <el-row :gutter="50">
            <div class="p_img" v-for="item in partnerList" :key="item">
              <img :src="item" alt="">
            </div>
          </div>
        </div> -->
        <!-- 合作伙伴 mobile -->
        <!-- <div class="partnerDivMobile">
          <el-row :gutter="15">
            <el-col :span="6" v-for="item in partnerList" :key="item">
              <el-image style="width: auto; height: 40px" :src="item" fit="contain" lazy></el-image>
            </el-col>
          </el-row>
          <div class="p_img" v-for="item in partnerList" :key="item">
              <img :src="item" alt="">
            </div>
        </div> -->
        <!-- <div class="partnerDivMobile">
          <div class="p_img" v-for="item in partnerList" :key="item">
              <img :src="item" alt="">
            </div>
        </div> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import HeadNav from "../components/head.vue";
import Title from "../components/title.vue";
// swiper的js导入
import Swiper from "../util/swiper/swiper.js";
import { getNewsList,getNavTitle, getCompany, getTheme,getShowEq } from "../api/allApiRequest.js";
export default {
  name: "HomePage",
  data() {
    return {
      //logo
      src: require("../assets/homepage.png"),
      width: 0,
      list: [],
      partnerList: [],
      DevicesList: [],
      companyImg: "",
      profiles: "",
      value: 0,
      headNavImg: {},
      devicesUlDS: "",
      proId1:"",
      proId2:"",
      proId3:"",
      proId4:"",
      proId5:"",
      proId6:"",
      proId7:"",
      isMobileFlag:false,
      getValue:"",
      getValue2:"",
      // 新闻
      newsData:[],
      queryInfo:{
        page:1,
        pageSize:6,
        newsType:1,
        category:''
      },
      total:0,
      pageTotal:0,//共几页,
      activeNewsIndex:0,//当前选中的某条新闻的id
      activeNewsDetail:{},//当前选中的某条新闻
      isPre:false,//是否是上一页
      isNext:false,//是否是下一页
      aboutUSText:'聚跃检测集团2012年成立于上海漕河泾，2019年将总部迁至张江，目前在上海设立三处实验室。同时为更好的贴近客户、服务好客户，先后在北京、合肥、成都、深圳、珠海、杭州设立子公司，在国内集成电路的主要阵地安营扎寨，形成“东、西、南、北、中”五大中心的产业布局。聚跃检测是一家专业的IC集成电路第三方综合服务提供商，主要为半导体集成电路领域内的设计公司、科研院所、晶圆代工厂、封装厂等产业上下游提供专业高效的芯片检验检测与分析服务。公司主要经营项目分为五大版块：失效分析实验室、可靠性验证实验室、先进制程分析、汽车电子实验室和材料分析实验室。'
    };
  },
  components: {
    HeadNav,
    Title
  },
  updated(){
    let txtSpan = document.querySelectorAll('.deviceTxt p span');
    if(this.isMobileFlag){
      for(let i in  txtSpan){
        txtSpan[i].style.cssText='white-space:initial;font-size:12px;'
      }
    }else{
      for(let i in  txtSpan){
        txtSpan[i].style.cssText='white-space:initial;font-size:24px;'
      }
    }
   
  },
  mounted() {
    this.getNews()
    this.getServicesList();
    this.value = location.hash.split("?")[1]
      ? location.hash.split("?")[1].split('&')[1].split("=")[1]
      : 0;
    this.getThemeHead();
    this.getShowEqIndex();

    // 轮播
    new Swiper(this.$refs['swiper-container'],{
        pagination: {
            el: this.$refs['swiper-pagination'],
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换。
        },
        loop : true, //无缝循环
        effect : 'fade',
        speed:3000,
        autoplay:{
            disableOnInteraction: false
        }
        
    })
  },
  created(){
    //  this. getCompanyList();
     this.isMobileFlag = this.IsPc()
  },
  methods: {
    getLeft() {
      let width = this.$refs.devicesUl.offsetWidth;
      this.$refs.devicesUl.onmouseover = () => {
        clearInterval(this.devicesUlDS);
      };
      this.$refs.devicesUl.onmouseout = () => {
        let devicesUl = this.$refs.devicesUl;
        this.devicesUlDS = setInterval(() => {
          if (width / 2 <= Math.abs(devicesUl.offsetLeft)) {
            devicesUl.style.left = "0px";
          }
          devicesUl.style.left = devicesUl.offsetLeft - 1 + "px";
        }, 16);
      };
      let devicesUl = this.$refs.devicesUl;
      this.devicesUlDS = setInterval(() => {
        if (width / 2 <= Math.abs(devicesUl.offsetLeft)) {
          devicesUl.style.left = "0px";
        }
        devicesUl.style.left = devicesUl.offsetLeft - 1 + "px";
      }, 16);
    },
    //服务项目
    getServicesList() {
      getNavTitle().then(res => {
        res.data.forEach(item => {
          if (item.title == "实验室服务项目") {
            for (var i = 0; i < item.children.length; i++) {
              if (item.children[i]) {
                item.children[i].picture =
                  process.env.VUE_APP_WEB_URL + item.children[i].picture;
                item.children[i].backPicture =
                  process.env.VUE_APP_WEB_URL + item.children[i].backPicture;
                 this.list.push(item.children[i]);
              }
            }
            this.getValue = item.id
            this.proId1 = this.list[0].children[0].id
            this.proId2 = this.list[7].children[0].id
            this.proId3 = this.list[2].children[0].id
            this.proId4 = this.list[3].children[0].id
            this.proId5 = this.list[4].children[0].id
            this.proId6 = this.list[5].children[0].id
            this.proId7 = this.list[6].children[0].id
            this. getCompanyList()
          }
          if(item.title == "设备销售"){
            this.getValue2 = item.id
          }
        });
      });
    },
    //公司信息返显
    getCompanyList() {
      getCompany().then(res => {
        this.companyImg = process.env.VUE_APP_WEB_URL + res.data.picture;
        this.profiles = res.data.profiles;
        let partnerList = res.data.partner.split(","),
          testEquipment = res.data.testEquipment.split(","),
          equipmentBrief = res.data.equipmentBrief.split("<p>[*]</p>");
        partnerList.forEach((item,index) => {
          this.partnerList.push(process.env.VUE_APP_WEB_URL+item);
        });
        // testEquipment.forEach((item,index) => {
        //   // this.DevicesList.push({src:process.env.VUE_APP_WEB_URL + item ,id:this.list[index].id});
        //   this.DevicesList.push({src:process.env.VUE_APP_WEB_URL + item,profile:equipmentBrief[index]});
        // });
        // setTimeout(() => {
        //   this.getLeft();
        // }, 500);
      });
    },
    //主题返现
    getThemeHead() {
      getTheme({
        themeType: 0
      }).then(res => {
        this.headNavImg = res.data.records[0];
        res.data.records[0].picture =
          process.env.VUE_APP_WEB_URL + res.data.records[0].picture;
      });
    },
    projectRow(e,idx){
      this.$router.push({ path: "LaboratoryServices" ,query:{ value:sessionStorage.getItem('value') ,cId:e}})
      sessionStorage.setItem('activeIndex','2-8')
      sessionStorage.setItem('type',idx)
    },
    projectRowMobile(item){
      this.$router.push('/LaboratoryServices?value=' + this.getValue + '&id='+ item.id)
    },
    goPage2(url){
      this.$router.push(url)
      sessionStorage.setItem('activeIndex','5-7')
      sessionStorage.setItem('type',7)
    },
    devicesDiv(e){
       this.$router.push({ path: "LaboratoryServices" ,query:{ value:sessionStorage.getItem('value') ,id:e}})
      sessionStorage.setItem('activeIndex',2)
    },
    getShowEqIndex(){
     getShowEq().then(res => {
        if(res.code == 1){
          let testEquipment = res.data;
          // this.DevicesList = res.data;
          testEquipment.forEach((item,index) => {
            if(item.equipmentBrief){
              this.DevicesList.push({src:process.env.VUE_APP_WEB_URL + item.testEquipment,profile:item.equipmentBrief,cId:item.defaultTypeId});
            }
          });
          setTimeout(() => {
            this.getLeft();
          }, 500);
        }
      });
    },
    goPage(url,idx){
      this.$router.push(url)
      sessionStorage.setItem('activeIndex',5)  //当是设备存5
      sessionStorage.setItem('type',"")
    },
    IsPc(){
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod", "wechatdevtools"];
      var flag = false;
      for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
              flag = true;
              break;
          }
      }
      return flag;
    },
    goAboutUs(path) {
      this.$router.push(path)
      sessionStorage.setItem('activeIndex','8-1')
      sessionStorage.setItem('type',1)
    },
    goAboutUsMoblie(path) {
      this.$router.push(path)
      sessionStorage.setItem('type',100);
      sessionStorage.setItem('mobileActiveName',6)
    },
    // 新闻
    //发布时间处理函数
    getTime(time) {
      var time = new Date(time);
      var year = time.getFullYear();
      var month = time.getMonth()+1 < 10 ? '0'+(time.getMonth()+1) : time.getMonth()+1;
      var day = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();
      return `${year}-${month}-${day}`;
    },
    // 新闻列表
    getNews() {
      getNewsList(this.queryInfo).then(res => {
        this.newsData = res.data.records;
        this.newsData.forEach(item=>{
          item.picture = process.env.VUE_APP_WEB_URL + item.picture
        })
        this.total = res.data.total;
        this.pageTotal = res.data.pages
        this.activeNewsDetail = this.newsData[0]
        if(this.isNext) {
           this.activeNewsDetail = this.newsData[0]
        }
        if(this.isPre) {
           this.activeNewsDetail = this.newsData[this.newsData.length-1]
        }
      });
    },
    goMoreNews(path) {
      this.$router.push(path)
      if(this.isMobileFlag) {
        // 手机
        sessionStorage.setItem('type',100)
      } else {
        sessionStorage.setItem('activeIndex',7)
        sessionStorage.setItem('type',1)
      }
    },
    // 下一个
    handleNext() {
      this.isNext = true;
      this.isPre = false;
      // 先判断当前是否是最后一页
      if (this.queryInfo.page == this.pageTotal) {
        // 是最后一页，再判断当前是否是最后一条新闻
        if(this.activeNewsIndex == this.newsData.length-1) {
          // 是最后一条新闻，则不做任何操作
          // alert("已经是最后一条新闻了！");
        } else {
          // 不是最后一条新闻，则将当前新闻id加一，并将当前新闻id置为第一条
          this.activeNewsIndex++;
          this.activeNewsDetail = this.newsData[this.activeNewsIndex];
        }
      } else {
        // 不是最后一页，先判断当前activeNewsIndex是否小于5，如果小于5，则activeNewsIndex加一，否则将page加一，activeNewsIndex置为0
        if (this.activeNewsIndex < 5) {
          this.activeNewsIndex++;
          this.activeNewsDetail = this.newsData[this.activeNewsIndex];
        } else {
          this.queryInfo.page++;
          this.activeNewsIndex = 0;
          this.getNews()
        }
      }
    },
    // 上一个
    handlePre() {
      this.isNext = false;
      this.isPre = true;
      // 先判断当前是否是第一页
      if (this.queryInfo.page == 1) {
        // 是第一页，再判断当前是否是第一条新闻
        if(this.activeNewsIndex == 0) {
          // 是第一条新闻，则不做任何操作
          // alert("已经是第一条新闻了！");
        } else {
          // 不是第一条新闻，则将当前新闻id减一，并将当前新闻id置为最后一条
          this.activeNewsIndex--;
          this.activeNewsDetail = this.newsData[this.activeNewsIndex];
        }
      } else {
        // 不是第一页，先判断当前activeNewsIndex是否大于等于0，如果大于等于0，则activeNewsIndex减一，否则将page减一，activeNewsIndex置为当前数组长度-1
        if(this.activeNewsIndex > 0) {
          this.activeNewsIndex--;
          this.activeNewsDetail = this.newsData[this.activeNewsIndex];
        } else {
          this.queryInfo.page--;
          this.activeNewsIndex = this.newsData.length-1;
          this.getNews()
        }
      }
    },
    getClickNewsDetail(item) {
      let id = item.id
      let link = item.link
      if(link) {
         window.open(link,'_blank')
      } else {
        if(this.isMobileFlag) {
          // 手机
          sessionStorage.setItem('type',100)
        } else {
          sessionStorage.setItem('activeIndex',7)
          sessionStorage.setItem('type',1)
        }
        this.$router.push('/newsDetail?value=02&id='+id)
      }
    }
  }
};
</script>

<style scoped>
 /* 引入swiper中的css */
  @import "../util/swiper/swiper.css";
.parentTitle{
  position:relative;
}
.parentTitle .titleHead{
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  text-align: center;
  font-weight: bold;
  text-shadow: 0px 5px 5px rgba(50,51,51,0.98);
}
.titleHead div {
  font-weight: 600;
  font-size: 30px;
  color: #fff;
}
.titleHead div:nth-child(2) {
  margin-top:20px;
  font-size: 24px;
}
.banner{
  height: 100%;
  width: 100%;
}
.banner img{
  height: 100%;
  width: 100%;
}
.navLogo{
   position: absolute;
   z-index: 10000;
   width: 15%;
   top: 21.5%;
   left: 45.5%;
   overflow: hidden;
   animation: navlogo 10s;
   animation-fill-mode: forwards; 
}
.navLogo>img{
   height: 100%;
}
.projectRow{
  margin:40px 0 0 0!important;
}
.firstImg,.secondImg{
  display: flex;
  justify-content: space-between;
  height: 300px;
}
.secondImg{
  height: 300px;
  margin-top:25px;
  display: flex;
  justify-content: space-between;
}
.firstImg img,.secondImg .right2 img,.secondImg .left2 div img,.secondImg .center2 div img{
  height: 100%;
  width: 100%;
}
.firstImg .left1{
  width: 68%;
  height:100%;
  position: relative;
  overflow: hidden;
}
.firstImg .right1{
  width:30%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.secondImg .left2,.secondImg .center2{
  width:68%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.secondImg .left3 {
  width:30%;
  height: 100%;
}
.secondImg .left3 .aa  {
  width:100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.secondImg .left3 .aa img {
  width:100%;
  height: 100%;
}
.secondImg .left2 .aa,.secondImg .center2 .aa{
  position: relative;
  overflow: hidden;
}
.secondImg .right2{
  height: 100%;
  width:30%;
  position: relative;
  overflow: hidden;
}
.secondImg .left2 div.aa,.secondImg .center2 div.aa{
  height: 300px;
  width: 48.5%;
}
/* .secondImg .left2 div.aa:nth-child(2),.secondImg .center2 div.aa:nth-child(2){
  margin-top:25px;
} */

.left1:hover .comTxtCont,.right1:hover .comTxtCont,.left2 .aa:hover .comTxtCont,.left3 .aa:hover .comTxtCont,.right2:hover .comTxtCont,.center2 .aa:hover .comTxtCont{
  transform:translateY(-190px);
  animation-play-state:running;
}
.left1:hover .comTxtCont{
   transform:translateY(-170px);
}
.left2 .aa:nth-child(2):hover .comTxtCont{
   transform:translateY(-200px);
}
.right2:hover .comTxtCont{
   transform:translateY(-400px);
}
.more{
  cursor: pointer;
  width: 144px;
  height: 44px;
  line-height: 44px;
  border-radius: 5px;
  font-size: 16px;
  color: #FFFFFF;
  background: rgba(0,0,0,0.76);
  text-align: center;
  margin: 15px 0;
  transition: all 0.3s linear;
}
.more:hover{
  background: #417ccb;
}
.comTxtCont{
  position: absolute;
  color:#fff;
  left: 0;
  top: 100%;
  width: 80%;
  padding: 15px 40px 15px 40px;
  margin-top: -88px;
  transition: all 0.3s linear;
}
.comTxtCont .comTitle{
  font-size: 28px;
  line-height: 120%;
}
.comTxtCont .comPro{
  font-size:16px;
  /* line-height: 170%; */
  line-height: 150%;
  margin:35px 0 20px 0;
  text-align: justify;
}
@keyframes navlogo {
   0%{
     transform: scale(1); 
   }
   50%{
     transform: scale(1.2); 
   }
   100%{
     transform: scale(1); 
   }
}
.deviceTxt{
  background:rgba(0, 0, 0, .4);
  /* padding: 0px 20px 20px; */
  width: 368px;
  height: 298px;
  position: absolute;
  top:0px;left:0px;
  transition: opacity 2s;
  opacity: 0;
  color:#fff;
  box-sizing: border-box;
  overflow: hidden;
  padding:0px 10px;
  text-align:center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.devicesUl li:hover .deviceTxt{
  opacity: 1;
  transition-duration: 0s;
}
.p_img{
  height:75px;
  width:168px;
  display: inline-block;
  margin: 10px 15px;
}
/* .p_img:nth-child(1),.p_img:nth-child(7){
  margin-left:0;
}
.p_img:nth-child(6),.p_img:nth-child(12){
  margin-right:0;
} */
.p_img img{
  width:100%;
}
.MarginPartner{
   /* padding:30px; */
   /* background-color: #f1f1f1; */
   padding-bottom:25px;
}
.imgAnimate {
  width: 80%;
  height: 400px;
  overflow: hidden;
}
.imgAnimate > img {
  cursor: pointer;
  transition: all 0.6s;
}
.imgAnimate > img:hover {
  transform: scale(1.4);
}
.devices {
  height: 310px;
  position: relative;
  overflow: hidden;
}
.partnerUl {
  height: 100px;
  width: 100%;
}
.devicesUl {
  height: 300px;
  list-style: none;
  position: absolute;
  white-space: nowrap;
  left: 0;
  padding: 0;
  margin: 0;
}
.devicesUl li {
  width: 370px;
  display: inline-block;
  margin: 0 10px;
  height: 100%;
  cursor: pointer;
  border:1px solid #ccc;
  padding:10px;
  box-sizing: border-box;
  position: relative;
}
.devicesUl1 li {
  width: 370px;
  margin: 0 40px;
  height: 100px;
}
.devicesUl li img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.partnerMobile {
  display: none;
}
.CompanyMobile {
  display: none;
}
.CompanyPc {
  margin-top: 40px;
}
.projectClass {
  margin: 0 auto;
  width: 1190px;
}
.projectBg{
  /* background:url(../assets/line.png) repeat center; */
  background-size:contain ;
  display: block;
  position: relative;
}
.projectBg::after{
  content: "";
  background:url(../assets/line.png) repeat center;
  opacity: 0.7;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;   
}

.title {
  font-size: 28px;
  color: #053b7b;
  text-align: center;
  font-weight: 800;
}

.Marigin {
  margin-top: 50px;
}

.titleMarigin {
  margin-top: 10px;
  font-family: Arial;
  font-style: italic;
}
.projectParent .pc{
  margin-bottom:0;
}
.deviceParent .pc{
  margin-top:40px;
}
.project {
  height: 240px;
  width: 100%;
  text-align: center;
  background-color: #053b7b;
  position: relative;
  margin: 20px 0;
  overflow: hidden;
}
.project > img {
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: all 0.6s;
}
.project > img:hover {
  transform: scale(1.2);
}
.projectIcon {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 18%;
}
.projectIcon img {
  width: 100%;
  height: 100%;
}
/* .projectText {
  width: 100%;
  font-size: 20px;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 77%;
  left: 50%;
  color: #fff;
  font-weight: bold;
} */
.projectText{
  position:absolute;
  bottom: 0;
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  height:80px;
  width:100%;
  /* background:rgba(0, 0, 0, .6); */
  line-height:80px;
}

.CompanyProfile {
  color: #666666;
}

.button {
  background-color: #053b7b;
  color: #fff;
  border: 1xp solid #053b7b;
}
.partner img {
  width: 100%;
  height: 150px;
}
.partnerDiv {
  width: 1190px;
  margin: 0 auto;
}
.projectRow {
  display: block;
  margin-top: 30px;
}
.projectRowMobile {
  display: none;
}
.partnerDivMobile {
  display: none;
}
.about_us {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.about_us_left {
  width: 36%;
}
.about_us_left img {
  width:100%;
}
.about_us_right {
  width: 62%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.about_us_right_top {
  font-size: 17px;
  line-height: 1.8;
  text-align: justify;
  letter-spacing: 1px;
}
.about_us_right_bottom {
  display: flex;
  flex-direction: row-reverse;
}
.about_us_right_bottom_button {
  padding: 10px 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0a59b2;
  color: #ffffff;
  cursor: pointer;
}
.about_us_mobile {
  display: none;
}
.news_pc {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  margin-top: -10px;
}
.news_pc_left {
  /* width: 58%; */
  width: 690px;
  border: 1px solid #e9e9e9;
  border-radius: 10px;
}
.news_pc_left_top {
  height: 460px;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  border-radius: 10px;
}
.news_pc_left_top img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  transition: all 0.3s linear;
}
.news_pc_left_top:hover img {
  transform: scale(1.05);
}
.news_pc_left_bottom {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
}
.news_pc_left_bottom_top {
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  width: 100%;
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 使用省略符号表示溢出的文本 */
}
.news_pc_left_bottom_middle {
  cursor: pointer;
  height: 54px;
  margin: 15px 0;
  font-size: 15px;
  width: 100%;
  display: -webkit-box;	
  text-overflow: -o-ellipsis-lastline;
  text-overflow: ellipsis;
  line-clamp: 2;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.8;
  color: #8c8c8c;
}
.news_pc_left_bottom_bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.news_pc_left_bottom_bottom_left {
  font-size: 15px;
  color: #8c8c8c;
  cursor: pointer;
}
.news_pc_left_bottom_bottom_right {
  display: flex;
}
.news_pc_left_bottom_bottom_right_button {
  width: 38px;
  height: 38px;
  cursor: pointer;
}
.news_pc_left_bottom_bottom_right_button img {
  width: 100%;
  height: 100%;
}
.news_pc_right {
  /* width: 40%; */
  width: calc(100% - 720px);
  border-radius: 10px;
  border: 1px solid #e9e9e9;
  padding-top: 20px;
}
.news_pc_right_top {
  padding: 0  20px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.news_pc_right_top_left {
  font-weight: 600;
}
.news_pc_right_top_right{
  color: #053b7b;
  font-size: 15px;
  cursor: pointer;
}
.news_pc_right_content {
  width: 100%;
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
}
.news_pc_right_content_item {
  cursor: pointer;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.news_pc_right_content_item:last-child {
  margin-bottom: 0;
}
.news_pc_right_content_item_left {
  width: 105px;
  height: 75px;
  border-radius: 5px;
  overflow: hidden;
}
.news_pc_right_content_item_left img{
  border-radius: 5px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s linear;
}
.news_pc_right_content_item_left:hover img {
  transform: scale(1.15);
}
.news_pc_right_content_item_right {
  height: 75px;
  width: calc(100% - 115px);
  /* padding-left: 10px; */
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.news_pc_right_content_item_right_title{
  width: 100%;
  font-weight: 600;
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 使用省略符号表示溢出的文本 */
}
.news_pc_right_content_item_right_time {
  font-size: 15px;
  color: #8c8c8c;
}
.news_line {
  display: none;
}
.news_mobile_right_bottom {
  display: none;
}
@media screen and (max-width: 1120px) {
  .news_pc_left {
    width: 50%;
  }
  .news_pc_right {
    width: 48%;
  }
}
@media screen and (max-width: 750px) {
  .p_img{
    height:40px;
    width:27.3%;
    display: inline-block;
    margin: 6px 3%;
  }
  .MarginPartner{
    padding: 0;
    background-color: #f1f1f1;
  }
  .partnerDivMobile {
    display: block;
    margin-bottom: 20px;
    padding-top:0px;
    /* background-color: #f1f1f1; */
  }
  .devicesUl li {
    width: 220px;
  }
  .devices {
    height: 137px;
    margin: 0;
  }
  .partnerDiv {
    display: none;
  }
  .CompanyMobile {
    display: block;
    margin-top: 20px;
  }
  .CompanyPc {
    display: none;
  }
  .projectRow {
    display: none;
  }
  .projectRowMobile {
    display: block;
    margin: 10px 0;
  }
  .projectClass {
    padding: 0 10px;
    width: 100%;
  }
  .project {
    height: 140px;
    margin: 10px 0;
  }
  .projectIcon {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    margin-left: -25px;
    top: 15%;
  }
  .projectRowMobile_top {
    height: 140px;
    width: 100%;
    position: relative;
  }
  .projectRowMobile_top img {
    height: 100%;
    width: 100%;
  }
  .projectRowMobile_bottom {
    margin-top:20px
  }
  .projectRowMobile_bottom_top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 140px;
  }
  .projectRowMobile_bottom_top_item {
    width: 48%;
    height: 100%;
  }
  .projectRowMobile_bottom_top_item img{
    width: 100%;
    height: 100%;
  }
  .partner {
    display: none;
  }
  .partnerMobile {
    display: block;
  }
  .partnerMobile img {
    height: 50px;
    width: 100%;
  }
  .parentTitle .titleHead div{
    font-size:18px;
    width:100%;
  }
  .parentTitle .titleHead div:nth-child(2){
    margin-top:10px;
  }
  .parentTitle .titleHead{
    width:100%;
  }
  .projectText{
    font-size: 14px;
    height: 53px;
    line-height: 22px;
    top: 63%;
    display: flex;
    align-items: center;
    /* justify-content: space-around; */
    padding:0 10px;
    box-sizing: border-box;
    font-weight:normal;
    text-align: left;
  }
  .devicesUl{
    height: 137px;
  }
  .deviceTxt{
    width: 218px;
    height: 135px;
  }
  .deviceTxt p span{
    font-size:12px!important;
  }
  /* .projectRowMobile.el-row{
    margin:0!important;
  }
  .projectRowMobile.el-row .el-col-12{
    padding:0px 10px!important;
  } */
  .pc{
    margin-top:20px;
  }
  .deviceParent .pc{
    margin-top:20px;
    margin-bottom:20px;
  }
  .partner2 .pc{
    margin-top:30px;
    margin-bottom:20px;
  }
  .about_us {
    display: none;
  }
  .about_us_mobile {
    display: block;
    margin-top: 20px;
  }
  .about_us_mobile_top {
    width: 100%;
  }
  .about_us_mobile_top img {
    width: 100%;
  }
  .about_us_mobile_middle{
    font-size: 14px;
    line-height: 1.5;
    text-align: justify;
    letter-spacing: 1px;
    margin: 15px 0 20px 0;
  }
  .about_us_mobile_bottom{
    display: flex;
    justify-content: center;
  }
  .about_us_mobile_bottom_button {
    padding: 8px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0a59b2;
    color: #ffffff;
    cursor: pointer;
  }
  .news_pc {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    border: 1px solid #e9e9e9;
    margin-bottom: 30px;
  }
  .news_pc_left {
    width: 100%;
    border: none;
  }
  .news_pc_left_top {
    height: 236px;
  }
  .news_pc_left_bottom {
    padding: 10px;
  }
  .news_pc_left_bottom_top {
    font-size: 14px;
  }
  .news_pc_left_bottom_middle {
    font-size: 12px;
    height: 38px;
    margin: 10px 0;
    line-height: 1.5;
  }
  .news_pc_left_bottom_bottom_left {
    font-size: 12px;
  }
  .news_pc_left_bottom_bottom_right_button {
    width: 30px;
    height: 30px;
  }
  .news_pc_right {
    width: 100%;
    border: none;
    padding-top:15px;
  }
  .news_pc_right_content {
    padding: 0 10px 10px;
  }
  .news_pc_right_content_item{
    margin-bottom:15px ;
  }
  .news_line {
    display: block;
    border: 1px solid #e9e9e9;
    margin:0 20px;
  }
  .news_pc_right_top {
    display: none;
  }
  .news_mobile_right_bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
  .news_mobile_right_bottom_button {
    padding: 8px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0a59b2;
    color: #ffffff;
    cursor: pointer;
  }
  .news_pc_right_content_item_left {
    width: 120px;
    height: 80px;
  }
  .news_pc_right_content_item_right {
    width: calc(100% - 130px);
    height: 80px;
  }
  .news_pc_right_content_item_right_title {
    font-size: 14px;
  }
  .news_pc_right_content_item_right_time{
    font-size: 12px;
  }
}
</style>
